import { render, staticRenderFns } from "./MobageIframe.vue?vue&type=template&id=4a837800&scoped=true&"
import script from "./MobageIframe.vue?vue&type=script&lang=js&"
export * from "./MobageIframe.vue?vue&type=script&lang=js&"
import style0 from "./MobageIframe.vue?vue&type=style&index=0&id=4a837800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a837800",
  null
  
)

component.options.__file = "MobageIframe.vue"
export default component.exports